export default "__VITE_ASSET__bc14e26b__"